export const API_URL = process.env.REACT_APP_API_URL as string;
export const TITLE = process.env.REACT_APP_TITLE as string;
export const HEADER_ENV = process.env.REACT_APP_HEADER_ENV as string;
export const BASENAME = process.env.REACT_APP_BASENAME as string;
export const BASE_URL = process.env.REACT_APP_BASE_URL as string;
export const PROJECT_ID = 3;
export const PROJECT_CATEGORY_ID = 8;
export const SPLIT_CODE = "@@@"; // selectの区切り文字
export const DATE_FORMAT = "YYYY-MM-DD";

export const APPLY_FORM_URL = `${BASE_URL}${BASENAME}/apply`;

export const EMAIL_ADDRESS_PARAM = 'email_address';

// attribute_settings
export const ATTRIBUTE_SETTING_IS_REQUIRED = '0010';
export const ATTRIBUTE_SETTING_LIMIT = '0020';
export const ATTRIBUTE_SETTING_DEFAULT_CODE = '0030';
export const ATTRIBUTE_SETTING_DEFAULT_VALUE = '0031';
export const ATTRIBUTE_SETTING_PARENT_ATTRIBUTE_ID = '0040';
export const ATTRIBUTE_SETTING_IS_AREA_RELATION = '0050';
export const ATTRIBUTE_SETTING_IS_BLOCK_RELATION = '0060';
export const ATTRIBUTE_SETTING_LIST_WIDTH = '0070';

// attribute_kinds_code
export const ATTRIBUTE_KINDS_CODE_TEXT_FIELD = '01';
export const ATTRIBUTE_KINDS_CODE_TEXT_AREA = '02';
export const ATTRIBUTE_KINDS_CODE_SELECT_BOX = '03';
export const ATTRIBUTE_KINDS_CODE_CHECK_BOX = '04';
export const ATTRIBUTE_KINDS_CODE_RADIO_BUTTON = '05';
export const ATTRIBUTE_KINDS_CODE_NUMBER_INT = '06';
export const ATTRIBUTE_KINDS_CODE_NUMBER_DECIMAL = '07';
export const ATTRIBUTE_KINDS_CODE_DATE = '08';

// file_attribute_code
export const FILE_ATTRIBUTE_CODE_ATTACHED_FILE = '10';  // 添付ファイル
export const FILE_ATTRIBUTE_CODE_APPLICATION_USE = '40';  // 道路管理者 - 利用申請書
export const FILE_ATTRIBUTE_CODE_CONSENT = '41';  // 道路管理者 - 承諾書
export const FILE_ATTRIBUTE_CODE_COPY_REQUEST = '42'; // 道路管理者 - 複製依頼書

export const ATTRIBUTE_COLUMN_NAME_INQUIRER_TYPE = 'inquirer_type'; // 道路管理者区分
export const ATTRIBUTE_COLUMN_NAME_GROUP_TYPE = 'group_type'; // 団体区分
export const ATTRIBUTE_COLUMN_NAME_GROUP_NAME = 'group_name'; // 法人・団体名
export const ATTRIBUTE_COLUMN_NAME_DEPARTMENT = 'department'; // 部署名・所属
export const ATTRIBUTE_COLUMN_NAME_SECTION = 'section'; // 課名
export const ATTRIBUTE_COLUMN_NAME_UNIT = 'unit'; // 室名または係名
export const ATTRIBUTE_COLUMN_NAME_POSITION = 'position'; // 役職
export const ATTRIBUTE_COLUMN_NAME_LAST_NAME = 'last_name'; // 氏
export const ATTRIBUTE_COLUMN_NAME_FIRST_NAME = 'first_name'; // 名
export const ATTRIBUTE_COLUMN_NAME_LAST_NAME_KANA = 'last_name_kana'; // せい
export const ATTRIBUTE_COLUMN_NAME_FIRST_NAME_KANA = 'first_name_kana'; // めい
export const ATTRIBUTE_COLUMN_NAME_EMAIL_ADDRESS = 'email_address'; // メールアドレス
export const ATTRIBUTE_COLUMN_NAME_PHONE_NUMBER = 'phone_number'; // 電話番号
export const ATTRIBUTE_COLUMN_NAME_ZIP_CODE = 'zip_code'; // 郵便番号
export const ATTRIBUTE_COLUMN_NAME_PREF = 'pref'; // 都道府県
export const ATTRIBUTE_COLUMN_NAME_CITY = 'city'; // 市区町村
export const ATTRIBUTE_COLUMN_NAME_HOUSE_NUMBER = 'house_number'; // 町名番地
export const ATTRIBUTE_COLUMN_NAME_BUILDING_NAME = 'building_name'; // 建物名・部屋番号
export const ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE1 = 'inquiry_type1'; // 問合せ区分1
export const ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE2 = 'inquiry_type2'; // 問合せ区分1
export const ATTRIBUTE_COLUMN_NAME_INQUIRY_TITLE = 'inquiry_title'; // 問合せ区分1
export const ATTRIBUTE_COLUMN_NAME_INQUIRY_DETAIL = 'inquiry_detail'; // 問合せ内容
export const ATTRIBUTE_COLUMN_NAME_PERSONAL_INFORMATION_HANDLING = 'personal_information_handling'; // 個人情報の取り扱い

export const ATTRIBUTE_COLUMN_NAMES = [
  ATTRIBUTE_COLUMN_NAME_INQUIRER_TYPE,
  ATTRIBUTE_COLUMN_NAME_GROUP_TYPE,
  ATTRIBUTE_COLUMN_NAME_GROUP_NAME,
  ATTRIBUTE_COLUMN_NAME_DEPARTMENT,
  ATTRIBUTE_COLUMN_NAME_SECTION,
  ATTRIBUTE_COLUMN_NAME_UNIT,
  ATTRIBUTE_COLUMN_NAME_POSITION,
  ATTRIBUTE_COLUMN_NAME_LAST_NAME,
  ATTRIBUTE_COLUMN_NAME_FIRST_NAME,
  ATTRIBUTE_COLUMN_NAME_LAST_NAME_KANA,
  ATTRIBUTE_COLUMN_NAME_FIRST_NAME_KANA,
  ATTRIBUTE_COLUMN_NAME_PHONE_NUMBER,
  ATTRIBUTE_COLUMN_NAME_ZIP_CODE,
  ATTRIBUTE_COLUMN_NAME_PREF,
  ATTRIBUTE_COLUMN_NAME_CITY,
  ATTRIBUTE_COLUMN_NAME_HOUSE_NUMBER,
  ATTRIBUTE_COLUMN_NAME_BUILDING_NAME,
  ATTRIBUTE_COLUMN_NAME_EMAIL_ADDRESS,
  ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE1,
  ATTRIBUTE_COLUMN_NAME_INQUIRY_TYPE2,
  ATTRIBUTE_COLUMN_NAME_INQUIRY_TITLE,
  ATTRIBUTE_COLUMN_NAME_INQUIRY_DETAIL,
  ATTRIBUTE_COLUMN_NAME_PERSONAL_INFORMATION_HANDLING,
];

export const ATTRIBUTE_CODES = [ATTRIBUTE_KINDS_CODE_SELECT_BOX, ATTRIBUTE_KINDS_CODE_CHECK_BOX, ATTRIBUTE_KINDS_CODE_RADIO_BUTTON];
export const ATTRIBUTE_MULTIPLE_CODES = [ATTRIBUTE_KINDS_CODE_CHECK_BOX];

export const MESSAGE_NO_E08 = ( name: string ) => {
  return `「${name}」は必須項目です。`;
}
export const MESSAGE_NO_E35 = ( name: string, num: number ) => {
  return `「${name}」は${num}文字以内で入力してください。`;
}
export const MESSAGE_NO_E09 = "郵便番号が存在しません。";
export const MESSAGE_NO_E10 = "申込エリアが重複しています。";
export const MESSAGE_NO_E11 = "合計容量が10ＭＢを超えています。";
export const MESSAGE_NO_E21 = "入力されたメールアドレスは利用できません。";
export const MESSAGE_NO_E36 = "「備考」は200字以内で入力してください。";
export const MESSAGE_NO_E37 = "データの保存に失敗しました。再度実行してください。";
export const MESSAGE_NO_E39 = "データの取得に失敗しました。再度実行してください。";
export const MESSAGE_NO_E41 = "コメントを送信してよろしいでしょうか？";
export const MESSAGE_NO_E66 = "コメントを入力してください。";